import { logoStyles } from "@insite/content-library/Widgets/Basic/Logo";
import { css } from "styled-components";

logoStyles.wrapper = {
    css: css`
    max-width: auto;
    max-height: 110px;
`,
}